import { useDispatch } from 'react-redux';
import { Link } from "react-router-dom";
import { startLogin } from '../../actions/auth';

import { useForm } from '../../hooks/useForm';

export const LoginScreen = () => {

  const dispatch = useDispatch()

  const [ formValues, handleInputChange ] = useForm( {
      
      Email: '',
      Password: ''
  });

  const {  Email, Password } = formValues;

  const handleLogin = ( e ) => {
    e.preventDefault()

    dispatch(startLogin( Email, Password))
}



  return (
    <div className='_auth'>

        <form onSubmit={ handleLogin } className="container row">
            <div className='col-12 col-lg-4'>
                        <h3>Iniciar sesión</h3>
                        <hr />

                        <div className="col-12 ">
                            <label htmlFor="email">Email de su cuenta</label>
                            <input
                                id='email'
                                type="email"
                                className="form-control mt-1 "
                                placeholder="Correo"
                                name= 'Email'
                                autoComplete='off'
                                value={ Email }
                                onChange={ handleInputChange }
                            />
                        </div>
                        <div className="col-12 ">
                            <label htmlFor="password ">Contraseña</label>
                            <input
                                id='password'
                                type="password"
                                className="form-control mt-1"
                                placeholder="Contraseña" 
                                name= 'Password'
                                value={ Password }
                                onChange={ handleInputChange }
                            />
                        </div>
                        <div className=" submit mt-4 ">
                            <input 
                                type="submit"
                                className=" btn_blue"
                                value="Iniciar sesión" 
                            />
                    <p className='mt-2'>no tienes una cuenta? <Link to="/register" className='nav-menu-items register'> registrate! <i className="fa-solid fa-right-to-bracket"></i></Link></p> 
                        </div>

            </div>
        </form>




    </div>

    
  )
}
